import React, { useState } from 'react'
import MobileBanner from '../../MobileGlobalComponents/MobileBanner/MobileBanner'
import CustomTextField from '../../../../../customComponents/CustomTextField'
import { truncateText } from '../../../../../utils/utils'

const MobileProductLevelTeam = ({ users, level }) => {
	const [itemsPerPage, setItemsPerPage] = useState(10)
	const [searchTerm, setSearchTerm] = useState('')

	const filteredUsers = users.filter(
		(user) =>
			user.registerId.toLowerCase().includes(searchTerm.toLowerCase()) ||
			user.fullName.toLowerCase().includes(searchTerm.toLowerCase()) ||
			user.mainUser.registerId.toLowerCase().includes(searchTerm.toLowerCase()) ||
			user.mainUser.fullName.toLowerCase().includes(searchTerm.toLowerCase())
	)

	return (
		<div className='mb-5 mt-5'>
			<div class='card container-fluid w-95 shadow-card mb-2 '>
				<div className='row d-flex justify-content-between align-items-center '>
					<div className=' col-8 text-center'>
						<h3 className='letter-normal text-bold text-black'>Product Level Team</h3>
					</div>
					<div className=' col-3 title-card-bg'>
						<img
							className='title-card-image ms-n5'
							src='https://png.pngtree.com/png-vector/20240313/ourmid/pngtree-report-finance-element-png-image_11936276.png'
							alt=''
						/>
					</div>
				</div>
			</div>
			<div className='mb-5 mt-5 display-mob bg-2'>
				{filteredUsers.map((user, index) => (
					<>
						<div key={user._id} className='card mt-2 container-fluid  shadow-card w-95 mb-2'>
							<div className='d-flex gap-2 justify-content-between align-items-center mt-2 mb-1'>
								<span class='bg-dark-yellow sno p-1 ms-1'>
									<b className='text-black-50 text-sm'>{index + 1}</b>
								</span>
								<div className='col-2 p-0 text-center ms-1'>
									<img
										className=' border-radius-2xl p-1 w-100'
										src={
											user?.gender === 'male'
												? 'https://demos.creative-tim.com/material-dashboard-pro/assets/img/kal-visuals-square.jpg'
												: 'https://demos.creative-tim.com/material-dashboard-pro/assets/img/team-3.jpg'
										}
										alt=''
									/>
								</div>
								<div className='col-8 mx-auto text-nowrap'>
									<div className='d-flex justify-content-between gap-4'>
										<div>
											<h6 className='text-bold text-uppercase'>{truncateText(user?.fullName, 15)}</h6>
											<p className='text-black text-md text-start lh-1'>{user?.registerId}</p>
										</div>
										<div>
											<h6 className='text-normal'>
												Level No : <b className=' fw-normal'>{level}</b>
											</h6>
											<p className='text-black text-md text-start lh-1'>
												{new Date(user?.createdAt).toLocaleDateString('en-GB').replace(/\//g, '-')}
											</p>
										</div>
									</div>
								</div>
							</div>
							<hr className='horizontal dark' />
							<div className='d-flex justify-content-start align-items-center my-2'>
								<div>
									<p className='text-black text-md text-start lh-1'>
										Upliner Id : <b className=' fw-bold'>{user?.mainUser?.registerId}</b>
									</p>
								</div>
							</div>
						</div>
					</>
				))}
			</div>
		</div>
	)
}

export default MobileProductLevelTeam
